import React, {useCallback, useEffect, useState} from 'react'
import {defineMessage, useIntl} from 'react-intl'
import styled from '@emotion/styled'
import {AnimatedLogo} from '@vio/atlas/AnimatedLogo'
import {Flex} from '@vio/atlas/helpers/Flex'
import {Text} from '@vio/atlas/Text'

const Wrapper = styled(Flex.Column)`
  height: 100%;
`

const loadingMessages = [
  defineMessage({
    id: 'dealFreeze.loadingFreezingPrice',
    defaultMessage: 'Freezing price...'
  }),
  defineMessage({
    id: 'dealFreeze.loadingHoldingRoom',
    defaultMessage: 'Holding room...'
  }),
  defineMessage({
    id: 'dealFreeze.loadingAlmostThere',
    defaultMessage: 'Almost there...'
  }),
  defineMessage({
    id: 'dealFreeze.loadingStillWorkingOnIt',
    defaultMessage: 'Still working on it...'
  })
]

const INTERVAL_TIMEOUT = 3000 // 3 seconds

export const LoadingIndicator = () => {
  const {formatMessage} = useIntl()
  const [current, setCurrent] = useState(0)

  const next = useCallback(() => {
    setCurrent(value => (value + 1) % loadingMessages.length)
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      next()
    }, INTERVAL_TIMEOUT)

    return () => {
      clearInterval(interval)
    }
  }, [next])

  return (
    <Wrapper alignItems="center" justifyContent="center" gap="s300">
      <AnimatedLogo size="lg" />
      <Text variant="titleL">{formatMessage(loadingMessages[current])}</Text>
    </Wrapper>
  )
}
